import { SelectOption, Typography, withForm } from '@stern-ui/ui';

import { patientAssignmentFormOptions } from './patientAssignmentFormOptions';

export const PatientAssignmentForm = withForm({
	...patientAssignmentFormOptions,
	props: {
		isLoading: false,
		patientStatusSelectOptions: [] as SelectOption[],
		studySelectOptions: [] as SelectOption[],
		hasSelectedPatients: false as boolean,
	},
	render: ({
		form,
		patientStatusSelectOptions,
		studySelectOptions,
		isLoading,
		hasSelectedPatients,
	}) => {
		return (
			<>
				<div
					className={`w-full grid grid-cols md:grid-cols-2 gap-4 md:gap-8 mt-6 pb-5 ${isLoading ? 'opacity-0' : ''}`}
				>
					<form.AppField name='study_identifier'>
						{(field) => (
							<field.SelectField label='Study' options={studySelectOptions || []} />
						)}
					</form.AppField>
					<form.AppField name='patient_status'>
						{(field) => (
							<field.SelectField
								label='Patient status'
								options={patientStatusSelectOptions}
							/>
						)}
					</form.AppField>
				</div>
				{hasSelectedPatients && (
					<div className='flex flex-col w-full flex-auto items-start mt-4 p-6 border border-secondaryBorder rounded-md'>
						<div className='flex w-full flex-auto items-center'>
							<form.AppField
								name='remove_new'
								children={(field) => (
									<field.CheckboxFieldV2
										boxSize='lg'
										label='Remove the ‘New’ flag from selected patients'
										labelClassName='!mb-0'
									/>
								)}
							/>
						</div>
						<Typography variant='body' className='text-secondaryTextDark mt-4'>
							Choosing this option will remove the ‘New’ label from their entry on the
							patient list.
						</Typography>
					</div>
				)}
			</>
		);
	},
});
